// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","easilBlack":"#2c2e2f","wrap":"style_wrap__4lVTE","header":"style_header__7YDTF"};